import { render } from "./productGridBlock.vue?vue&type=template&id=a584bf56&ts=true"
import script from "./productGridBlock.vue?vue&type=script&lang=ts"
export * from "./productGridBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__